import $ from 'jquery'
import 'jquery-countdown'
import moment from 'moment-timezone'

export default {
  inserted (el, binding) {
    const date = moment.tz(binding.value, 'YYYY-MM-DD HH:mm:ss', 'UTC')
      .local()
      .format('YYYY-MM-DD HH:mm:ss')

    $(el).countdown(date, (event) => {
      if (event.elapsed) {
        $(el).text('Expired')
      } else {
        $(el).text(event.strftime('%D days %H:%M:%S'))
      }
    })
  },

  update (el, binding) {
    const date = moment.tz(binding.value, 'YYYY-MM-DD HH:mm:ss', 'UTC')
      .local()
      .format('YYYY-MM-DD HH:mm:ss')

    $(el).countdown(date)
  }
}
